import {Shield, Award, Users, Clock} from 'lucide-react'

const badges = [
  { icon: Shield, label: 'Fully Insured', value: '$5M Liability' },
  { icon: Award, label: 'Certified', value: 'WCB & ISNetworld' },
  { icon: Users, label: 'Trained Staff', value: 'Background-Checked' },
  { icon: Clock, label: '24/7 Support', value: 'Emergency Response' },
]

function TrustBadges() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {badges.map((badge) => {
        const Icon = badge.icon
        return (
          <div
            key={badge.label}
            className="bg-white border border-soft rounded-xl p-5 md:p-6 flex items-center gap-4 hover-lift"
          >
            <div className="w-11 h-11 rounded-lg bg-orange-accent/10 flex items-center justify-center flex-shrink-0">
              <Icon className="w-5 h-5 text-orange-accent" />
            </div>
            <div className="min-w-0">
              <div className="text-xs uppercase tracking-wider text-muted font-semibold">{badge.label}</div>
              <div className="text-navy font-semibold text-sm mt-0.5 truncate">{badge.value}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TrustBadges
